import { withIonLifeCycle } from '@ionic/react';

const Loading = (props: any) => {
  return <div></div>;
};

export default withIonLifeCycle(Loading);
